import React from 'react';
import './RecentProjects.scss';

import { motion } from 'framer-motion';
import Tilt from 'react-parallax-tilt';

import { homePage } from '../../../editable-stuff/config';
import GradientButton from '../../../Library/GradientButton/GradientButton';

export default function RecentProjects() {
  return (
    <section id='recent-projects' className='p-150'>
      <div className='wave-top'>
        <svg
          fill='#ffffff'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='headers text-center mb-8'>
        <motion.h4
          initial={{ y: '100px', opacity: 0 }}
          whileInView={{ y: '0', opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {homePage?.recentProject?.title}
        </motion.h4>
        <motion.h2
          className='gradient'
          initial={{ y: '100px', opacity: 0 }}
          whileInView={{ y: '0', opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {homePage?.recentProject?.gradient_title}
        </motion.h2>
      </div>
      <div className='row no-gutters'>
        {homePage?.recentProject?.projects?.map((project, index) => (
          <div className='col-12 col-sm-6 col-lg-3 single-wrapper'>
            <Tilt scale={1.03} tiltMaxAngleX={5} tiltMaxAngleY={5}>
              <a href={project?.link} className='single'>
                <div className='content' data-fade='' style={{ opacity: 1 }}>
                  <h2>{project?.title}</h2>
                  <h5>{project?.subTitle}</h5>
                </div>
                <div className='image'>
                  <img loading='lazy' src={project?.img} alt='genvid project' />
                </div>
              </a>
            </Tilt>
          </div>
        ))}
      </div>
      <div className='row no-gutters mt-8'>
        <div className='buttons col-12 text-center'>
          <GradientButton
            text={homePage?.recentProject?.button.text}
            svg={homePage?.recentProject?.button.svg}
            link={homePage?.recentProject?.button.link}
            noMarginTop={true}
          />
        </div>
      </div>
    </section>
  );
}
